var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"consoleBox",staticClass:"console-box u-fill u-scrollable"},[_c('div',{ref:"container",staticClass:"outputs is-family-code",class:{'outputs-padded': !_vm.noPadding}},_vm._l((_vm.outputs),function(output,i){return _c('span',{key:i,staticClass:"output",class:{
            'output-error': output.type === 'err',
            'output-grade': output.type === 'grade',
        }},[_vm._v(_vm._s(output.value))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }